import { Result } from "../models/interfaces";
import { BaseService } from "./BaseService";

export type Teller = {
  id?: number;
  name?: string;
  userId?: number;
  userName?: string;
  transactionLimit?: number;
  transactionTypes?: string[];
  tellerAccountId?: number;
};

export type TillRequest = {
  narration?: string;
  amount?: number;
  requestStatus?: number;
  date?: Date;
  accountNo?: string;
  accountName?: string;
  accountId?: number;
};

export class TellerService extends BaseService {
  private tellerApi: string = "tellers";

  async getTellers(params: {
    userId?: number;
    tellerName?: string;
    pageIndex?: number;
    recordCount?: number;
  }): Promise<Result<Teller[]>> {
    var queryParams = this.ToQueryString(params);
    return this.get(`${this.tellerApi}${queryParams}`);
  }

  async getTeller(id: number): Promise<Result<Teller>> {
    return this.get(`${this.tellerApi}/${id}`);
  }

  async addOrUpdateTeller(
    params: {
      name: string;
      userId?: number;
      vaultAccountId?: number;
      tillAccountId?: number;
      transactionLimit?: number;
    },
    id?: number
  ): Promise<Result<Teller | boolean>> {
    if (!id) {
      return this.post(`${this.tellerApi}`, params);
    } else {
      return this.put(`${this.tellerApi}/${id}`, params);
    }
  }

  async deleteTeller(id: number): Promise<Result<boolean>> {
    return this.delete(`${this.tellerApi}/${id}`);
  }
}

export default new TellerService();
